<template>
  <b-overlay id="overlay-background" class="overlay-config calendar-seasonal" :show="loading" rounded="sm">
    <span :class="{ 'filter-kpi': true, hide: loading }">
      <label for="filter-kpi">{{ $t('filtro') }} </label>
      <input type="text" name="filter-kpi" class="ml-1" :placeholder="$t('procure-por')" v-model="filter" />
    </span>
    <div :class="{ 'screen-block': !idCalendar, 'screen-able': idCalendar }" :title="$t('adicione-um-calendario')">
    </div>
    <div class="bodycard">
      <b-table id="table-seasonal-indicators" class="height-indicators" hover sticky-header striped small
        :items="indicators" :fields="fields" sort-by="id">
        <template v-slot:cell(link)="row">
          <b-form-checkbox class="checkbox-icon" :disabled="row.item.disabled || disabledCheckBox"
            :idIndicator="row.indicatorName" v-model="row.item.link" @change="setLink(row)" :name="row.indicatorName">
          </b-form-checkbox>
        </template>
      </b-table>
    </div>
    <b-modal id="showForceSelectedIndicator" ok-variant="danger" :title="$t('atencao')" :ok-title="$t('yes')"
      :cancel-title="$t('no')" @ok="setLink(transientRow, force = true)" @cancel="reset(transientRow)">{{
        $t('indicador-ja-vinculado-ao-outro-calendario-deseja-vincular-a-este') }}
    </b-modal>
  </b-overlay>
</template>

<script>
import axios from 'axios'
import { defaultSuccess, urlMainAPI } from '../../../global'
import SeasonalIndicatorCalendar from '../model/SeasonalIndicatorCalendar.js'
import SeasonalCalendarRepository from '../service/SeasonalCalendarRepository';

export default {
  name: "TableIndicator",
  props: ["idCalendar", "refreshTableCalendar"],

  data: function () {
    return {
      indicators: [],
      indicatorsBkp: [],
      fields: [
        { key: "indicatorName", label: this.$t('indicadores-0') },
        { key: "link", label: this.$t('vincular') },
      ],
      linkIndicator: null,
      disabledCheckBox: false,
      loading: false,
      transientRow: null,
      check: null,
      filter: ""
    }
  },

  watch: {
    loading(val) {
      SeasonalCalendarRepository.fullLoading = val
    },

    localRefresh() {
      this.$emit("refreshTableCalendar", Math.random())
    },

    async idCalendar() {
      this.loading = true
      this.indicators = []
      await this.loadIndicators(this.idCalendar)
      this.loading = false
    },

    filter() {
      if (!this.filter) {
        this.indicators = this.indicatorsBkp
      }
      else {
        this.indicators = this.indicatorsBkp.filter(i => i.indicatorName.toLocaleUpperCase().includes(this.filter.toLocaleUpperCase()))
      }
    }
  },

  methods: {
    async loadIndicators(idCalendar) {
      let url = `${urlMainAPI}/getindicatorseasonalcalendar/`
      url = idCalendar && idCalendar != 0 ? url + `${idCalendar}` : url + `0`
      await axios.get(url).then(res => {
        if (res.status == 200) {
          this.indicatorsBkp = res.data.map(i => new SeasonalIndicatorCalendar(i, idCalendar));

          this.indicators = this.indicatorsBkp
          
          let hasLink = this.indicators.filter(item => item.link == true)

          if (hasLink.length > 0) {
            this.indicators.forEach(item => {
              if (item.indicatorId != hasLink[0].indicatorId) {
                item.disabled = true
              } else {
                item.disabled = false;
              }
            })
          }
          SeasonalCalendarRepository.indicatorsRelatedIDS = [...res.data].map(item => item.calendarId);
          SeasonalCalendarRepository.indicatorsRelated = [...res.data];
          this.$emit("refreshTableCalendar", Math.random())

        }
      }).catch(console.error)
    },

    async setLink(row, force = false) {
      this.transientRow = row;
      this.loading = true;
      this.disabledCheckBox = true;

      if (row.item.link == false) {
        this.indicators.forEach(ind => ind.disabled = false)
      } else {
        this.indicators.forEach(ind => {
          if (ind.indicatorId == row.item.indicatorId) ind.disabled = false;
          else ind.disabled = true;
        })
      }
      
      this.check = Boolean(row.item.link)
      if(this.check == true){
        if(!SeasonalCalendarRepository.indicatorsRelatedIDS.includes(row.item.calendarId)){
          SeasonalCalendarRepository.indicatorsRelatedIDS.push(row.item.calendarId)
          SeasonalCalendarRepository.indicatorsRelated.push(row.item)
        }
      }else{
        SeasonalCalendarRepository.indicatorsRelatedIDS = SeasonalCalendarRepository.indicatorsRelatedIDS.filter(item => item != row.item.calendarId)
        SeasonalCalendarRepository.indicatorsRelated = SeasonalCalendarRepository.indicatorsRelated.filter(item => item.calendarId != row.item.calendarId)
      }
      let keyIndicator = `${row.item.indicatorId}-${row.item.productionUnitId}-${row.item.system}`
      const url = `${urlMainAPI}/checkindicatorseasonalcalendar/${keyIndicator}/${row.item.calendarId}/${this.check}/${force}`
      await axios.get(url).then(res => {
        if (res.data == false) {
          this.$bvModal.show('showForceSelectedIndicator')
        } else {
          if (this.check == true) defaultSuccess(this.$t('indicador') + ' ' + `${row.item.indicatorName}` + ' ' + this.$t('vinculado-com-sucesso'))
          else defaultSuccess(this.$t('indicador') + ' ' + `${row.item.indicatorName}` + ' ' + this.$t('desvinculado-com-sucesso'))
        }
      }).catch(console.error)
      
      this.$emit("refreshTableCalendar", Math.random())
      this.loading = false;
      this.disabledCheckBox = false;
    },


    reset(row) {
      this.loading = true;
      row.item.link = false;
      this.loading = false;
    }
  },

  async mounted() {
    this.loading = true;
    await this.loadIndicators()
    this.localRefresh = this.refreshTableCalendar;
    this.loading = false;
  },
}
</script>

<style scoped>
.calendar-seasonal {
  height: inherit;
  margin: 0 0 4px 8px;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 0 2px #0008;
}

.bodycard,
.height-indicators {
  height: calc(100% - 15px);
  max-height: 100%;
}

.screen-block {
  position: absolute;
  display: block;
  width: 100%;
  height: calc(100% - 29px);
  ;
  background: #0002;
  z-index: 3;
  left: 0px;
  font-weight: 500;
  text-align: center;
  border-radius: 4px;
}

.screen-able {
  display: none;
}

.filter-kpi {
  display: flex;
  padding: 2px 0 2px 0;
}

.filter-kpi>label {
  margin: 0;
  width: 40px;
}

.filter-kpi>input {
  border: 2px solid black;
  border-radius: 4px;
  height: 25px;
  width: calc(100% - 40px);
}
</style>

<style>
.height-indicators>table>thead>tr>th:last-child {
  text-align: center;
}

.checkbox-icon {
  text-align: center;
}
</style>
